import { Component } from '@theme/component';

const parisDate = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
});
const parisOffset = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Europe/Paris', timeZoneName: 'longOffset',
});

/** Seconds until the next Paris midnight, including daylight-saving changes. */
export function secondsUntilParisMidnight(now = new Date()) {
  const parts = Object.fromEntries(parisDate.formatToParts(now).map(({ type, value }) => [type, value]));
  const utcMidnight = Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day) + 1);
  const offset = parisOffset.formatToParts(new Date(utcMidnight))
    .find(({ type }) => type === 'timeZoneName').value.match(/GMT([+-])(\d{2}):(\d{2})/);
  const minutes = offset ? (Number(offset[2]) * 60 + Number(offset[3])) * (offset[1] === '+' ? 1 : -1) : 0;
  return Math.max(0, Math.ceil((utcMidnight - minutes * 60000 - now.getTime()) / 1000));
}

/** @extends {Component<{hours: HTMLElement, minutes: HTMLElement, seconds: HTMLElement}>} */
class DailyCountdown extends Component {
  requiredRefs = ['hours', 'minutes', 'seconds'];
  #interval;

  connectedCallback() {
    super.connectedCallback();
    clearInterval(this.#interval);
    this.#update();
    this.#interval = setInterval(() => this.#update(), 1000);
  }

  updatedCallback() {
    super.updatedCallback();
    this.#update();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.#interval);
  }

  #update() {
    const remaining = secondsUntilParisMidnight();
    this.refs.hours.textContent = String(Math.floor(remaining / 3600)).padStart(2, '0');
    this.refs.minutes.textContent = String(Math.floor(remaining / 60) % 60).padStart(2, '0');
    this.refs.seconds.textContent = String(remaining % 60).padStart(2, '0');
    this.hidden = false;
  }
}

if (!customElements.get('vd-daily-countdown')) customElements.define('vd-daily-countdown', DailyCountdown);
